import React from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import { OverlayTrigger, Icon, ExternalLink } from "components/common";
const QueryHelpButton = styled(Button)`
  padding: 6px;
`;
const ExampleWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.global.background};
  border-radius: 6px;
  padding: ${({ theme }) => theme.spacings.sm};
  white-space: pre-wrap;
  width: 100%;
  margin: ${({ theme }) => theme.spacings.xs} 0;
  line-height: 1.7;

  & code {
    background-color: transparent;
  }
`;
const getStringVariable = (content) => /* @__PURE__ */ React.createElement("code", null, "${", content, "}");
const StringVariable = ({ content }) => getStringVariable(content);
const JmteLink = ({ children = void 0 }) => /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://www.tinymediamanager.org/docs/jmte", target: "_blank" }, children);
function Overlay() {
  const { t } = useTranslation("event_definitions");
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "summary_template_help.intro",
      components: { jmteLink: /* @__PURE__ */ React.createElement(JmteLink, null), variable: /* @__PURE__ */ React.createElement(StringVariable, { content: "..." }) }
    }
  )), /* @__PURE__ */ React.createElement("strong", null, t("summary_template_help.event_definition_variables")), /* @__PURE__ */ React.createElement(ExampleWrapper, null, getStringVariable("event_definition_id"), /* @__PURE__ */ React.createElement("br", null), getStringVariable("event_definition_title"), /* @__PURE__ */ React.createElement("br", null), getStringVariable("event_definition_type"), /* @__PURE__ */ React.createElement("br", null), getStringVariable("event_definition_description")), /* @__PURE__ */ React.createElement("strong", null, t("summary_template_help.custom_fields")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "summary_template_help.custom_fields_description", components: { code: /* @__PURE__ */ React.createElement("code", null) } })), /* @__PURE__ */ React.createElement(ExampleWrapper, null, getStringVariable("fields.my_custom_field")), /* @__PURE__ */ React.createElement("strong", null, t("summary_template_help.source_context")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "summary_template_help.source_context_description", components: { code: /* @__PURE__ */ React.createElement("code", null) } })), /* @__PURE__ */ React.createElement("p", null, t("summary_template_help.filter_events")), /* @__PURE__ */ React.createElement(ExampleWrapper, null, getStringVariable("source.source"), " ", t("summary_template_help.hostname"), /* @__PURE__ */ React.createElement("br", null), getStringVariable("source.message"), /* @__PURE__ */ React.createElement("br", null), getStringVariable("source.timestamp"), /* @__PURE__ */ React.createElement("br", null), getStringVariable("source.some_extracted_field")), /* @__PURE__ */ React.createElement("p", null, t("summary_template_help.aggregation_events")), /* @__PURE__ */ React.createElement(ExampleWrapper, null, getStringVariable("source.username"), " ", t("summary_template_help.group_by_field"), /* @__PURE__ */ React.createElement("br", null), getStringVariable("source.aggregation_value_count_source_bytes_sent"), /* @__PURE__ */ React.createElement("br", null), getStringVariable("source.aggregation_key")), /* @__PURE__ */ React.createElement("strong", null, t("summary_template_help.examples")), /* @__PURE__ */ React.createElement("p", null, t("summary_template_help.filter_example")), /* @__PURE__ */ React.createElement(ExampleWrapper, null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "summary_template_help.filter_example_template",
      components: {
        hostVariable: /* @__PURE__ */ React.createElement(StringVariable, { content: "source.source" }),
        messageVariable: /* @__PURE__ */ React.createElement(StringVariable, { content: "source.message" })
      }
    }
  )), /* @__PURE__ */ React.createElement("p", null, t("summary_template_help.aggregation_example")), /* @__PURE__ */ React.createElement(ExampleWrapper, null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "summary_template_help.aggregation_example_template",
      components: {
        userVariable: /* @__PURE__ */ React.createElement(StringVariable, { content: "fields.user" }),
        countVariable: /* @__PURE__ */ React.createElement(StringVariable, { content: "source.aggregation_value_count" })
      }
    }
  )));
}
function EventSummaryTemplateHelp() {
  const { t } = useTranslation("event_definitions");
  return /* @__PURE__ */ React.createElement(
    OverlayTrigger,
    {
      trigger: "click",
      rootClose: true,
      placement: "right",
      title: t("summary_template_help.title"),
      width: 500,
      overlay: /* @__PURE__ */ React.createElement(Overlay, null)
    },
    /* @__PURE__ */ React.createElement(
      QueryHelpButton,
      {
        bsStyle: "link",
        title: t("summary_template_help.button_title"),
        "aria-label": t("summary_template_help.button_aria_label")
      },
      /* @__PURE__ */ React.createElement(Icon, { name: "help" })
    )
  );
}
export default EventSummaryTemplateHelp;
